import logging from '@sstdev/lib_logging';
import lodash from 'lodash';
const { merge } = lodash;

export default _private => {
    const { startPromise, collection } = _private;
    return (docs, mergeIntoInserts) => {
        return startPromise.then(() => {
            let updated = 0,
                inserted = 0,
                errors = 0;
            // Which documents did NOT land. `errors` alone only says something went wrong, so a
            // caller that needs to know a specific row now holds the server's values (the stage-2
            // disagreement resolution, #1978) cannot tell a refreshed row from a stale one.
            const failedIds = [];
            for (const doc of docs) {
                try {
                    const foundDoc = collection.by('_id', doc._id);
                    if (foundDoc) {
                        const newDoc = {
                            ...doc,
                            // meta.forTempQueryResult survives this merge intentionally — consumed by the
                            // Phase 3 display gate (#332) so subsequent pages of the same query keep the tag.
                            meta: {
                                ...foundDoc.meta,
                                ...doc.meta
                            },
                            $loki: foundDoc.$loki,
                            _idx: foundDoc._idx
                        };
                        collection.update(newDoc);
                        updated++;
                    } else {
                        merge(doc, mergeIntoInserts);
                        collection.insert(doc);
                        inserted++;
                    }
                } catch (err) {
                    errors++;
                    // Only ids we can actually name; a doc with no _id cannot be reported by one,
                    // and `errors` still counts it.
                    if (doc?._id) failedIds.push(doc._id);
                    logging.error(err);
                }
            }
            return { updated, inserted, errors, failedIds };
        });
    };
};
